import { flattenValues } from "@uniformdev/canvas";

import { ValuePropCardData } from "@/libraries/design/patterns/value-props/src/value-prop-card";
import ValueProps, {
    MediaAspectRatio
} from "@/libraries/design/patterns/value-props/src/value-props";

interface UniformValuePropsProps {
    /** Section title */
    title: string;
    /** Array of value prop card data (from Uniform CMS) */
    cards: ValuePropCardData[];
    /** Media aspect ratio — either 1:1 or 16:9 */
    mediaAspectRatio?: MediaAspectRatio;
}

const UniformValueProps = ({
    title,
    cards,
    mediaAspectRatio
}: UniformValuePropsProps) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flattenedCards = flattenValues(cards as any) as ValuePropCardData[];

    return (
        <ValueProps
            title={title}
            cards={flattenedCards}
            mediaAspectRatio={mediaAspectRatio}
        />
    );
};

export default UniformValueProps;
